<template>
  <li class="nav-item">
    <a class="navigation-link item logged mr-2 no-underline" href="/sales">
      <span class="link-text">Sales</span>
      <span v-if="items > 0" class="numb">{{items}}</span>
    </a>
  </li>
</template>

<script>
export default {
  data() {
    return {
      items: 0,
      loading: false,
    };
  },

  created() {
    this.getItems();
  },

  methods: {

    getItems() {

      this.loading = true;

      axios
        .get('/new-sales')
        .then((response) => {
          this.items = response.data;
          this.loading = false;
        });

    },

  },
};
</script>
